import React from 'react';
import { CreateBox } from 'modules/product/pages';
import { BaasicInput, BaasicWarningModal, BaasicModal, BaasicSelect, Loader, BaasicCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const DimensionsStepTemplate = ({
	t,
	form,
	productEditViewStore: {
		loading,
		conflictWarningModal,
		conflictErrorModal,
		dimensionUnitOptions,
		weightUnitOptions,
		onChange,
		boxOptions,
		openCreateBoxModal,
		createBoxModal,
		onAutomaticBoxCheck,
		automaticBox,
		handleOnBoxMenuScroll,
		debouncedBoxSearch,
		onMenuClose,
		isBoxDropdownLoading,
		timer,
		onOuncesChange,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<div>
			<section>
				<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.DIMENSIONSSTEP')}</h3>
				<div className="row">
					<div className="col col-sml-12 col-lrg-12 col-xxlrg-10">
						<div className="row">
							<div className="col col-sml-12">
								<div className="row">
									<div className="col col-sml-6">
										<BaasicSelect
											field={form.$('dimensionUnit')}
											clearable={false}
											options={dimensionUnitOptions}
											value={form.$('dimensionUnit').value}
											onChange={value => onChange(value, form.$('dimensionUnit'))}
											className="spc--bottom--sml flex--grow--1"
										/>
										<BaasicInput field={form.$('length')} />
										<BaasicInput field={form.$('width')} />
										<BaasicInput field={form.$('height')} />
										<BaasicSelect
											field={form.$('box')}
											isClearable={true}
											options={boxOptions.slice()}
											value={form.$('box').value}
											onChange={value => onChange(value, form.$('box'))}
											onMenuScrollToBottom={handleOnBoxMenuScroll}
											onInputChange={debouncedBoxSearch}
											isLoading={isBoxDropdownLoading}
											onMenuClose={onMenuClose}
											className="spc--bottom--tny flex--grow--1"
										/>
										<div className="spc--bottom--sml">
											<BaasicCheckbox
												id={form.$('automaticBox').id}
												onChange={onAutomaticBoxCheck}
												label="PRODUCTVIEW.AUTOMATICBOX"
												checked={automaticBox}
											/>
										</div>
										<div className="spc--top--sml">
											<button
												title={t('ADDNEWBOX')}
												className="btn btn--med btn--primary"
												onClick={() => openCreateBoxModal()}
												type="button"
											>
												<i className="fa fa-plus spc--right--sml"></i>
												{t('ADDNEWBOX')}
											</button>
										</div>
									</div>
									<div className="col col-sml-6">
										<div className="inputgroup spc--bottom--sml">
											<BaasicSelect
												field={form.$('weightUnit')}
												clearable={false}
												options={weightUnitOptions}
												value={form.$('weightUnit').value}
												onChange={value => onChange(value, form.$('weightUnit'), true)}
											/>
										</div>
										{form.$('weightUnit').value.label == 'Kilograms' ? (
											<BaasicInput field={form.$('weight')} />
										) : (
											<div className="row">
												<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
													<BaasicInput onValueChange={timer(form.$('pounds').value)} field={form.$('pounds')} />
												</div>
												<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
													<BaasicInput onKeyUp={e => onOuncesChange(form.$('ounces').value)} field={form.$('ounces')} />
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<BaasicModal modalParams={createBoxModal}>
				<CreateBox />
			</BaasicModal>
			<BaasicWarningModal modalParams={conflictWarningModal} />
		</div>
	);
};

export default defaultTemplate(DimensionsStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/wizard/pages/DimensionsStepTemplate.jsx